document.addEventListener('DOMContentLoaded', function() {
    // Event listeners for arrows
    document.querySelector('.arrow.left').addEventListener('click', function() {
        scrollContainer(-1);
    });

    document.querySelector('.arrow.right').addEventListener('click', function() {
        scrollContainer(1);
    });

    function scrollContainer(direction) {
        const container = document.querySelector('.container');
        const scrollAmount = direction * (container.clientWidth / 2);
        container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }

    // Touch event support for mobile
    let startX = 0;
    let scrollLeft = 0;

    const container = document.querySelector('.container');

    container.addEventListener('touchstart', function(e) {
        startX = e.touches[0].pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
    });

    container.addEventListener('touchmove', function(e) {
        const x = e.touches[0].pageX - container.offsetLeft;
        const walk = (x - startX) * 2; // scroll-fast
        container.scrollLeft = scrollLeft - walk;
    });

    // Optional: CSS class for no-scrollbar visibility on touch
    container.classList.add('no-scrollbar');
});